export default function showQuickSaveList(userDuck, personalizationClient, inventoryDuck, savedInventoryDuck) {
  return () => async (dispatch, getState) => {
    const savedInventory = typeof getState().toJS === 'function' ? getState().get('savedInventory') : getState().savedInventory;
    const inventory = typeof getState().toJS === 'function' ? getState().get('inventory') : getState().inventory;

    // get list of saved ids in local storage
    const localStorageInventoryIds = await personalizationClient.getSavedInventoryItems();

    // get current count
    const inventoryCount = savedInventoryDuck.selectors.getSavedInventoryCount({
      savedInventory
    });

    // current savedInventory ids
    let savedInventoryIds = savedInventory.inventory.map(item => item.listingId);
    if (localStorageInventoryIds.length > 0) {
      savedInventoryIds = localStorageInventoryIds;
    }

    // get listing details and remove expired listings
    let inventoryDetails = await personalizationClient.hydrateInventoryItems(savedInventoryIds);
    inventoryDetails = inventoryDetails.filter(item => item.type !== 'Expired');
    const hasExpiredListings = inventoryDetails.length < localStorageInventoryIds.length || inventoryCount > 0 && localStorageInventoryIds.length === 0;
    if (hasExpiredListings) {
      dispatch(userDuck.creators.setGlobalAlert({
        key: 'expiredListings'
      }));
      // update local storage with valid listings
      personalizationClient.setInventoryItems(inventoryDetails.map(item => item.id));
      // update bookmark ids
      dispatch(userDuck.creators.setSavedInventoryItems(inventoryDetails.map(item => item.id)));
    }

    // update the quick save inventory collection after indexing by id
    inventoryDetails.forEach((item, index) => {
      if (inventory[item.id]) {
        // need to make sure we use images in inventory to avoid deepmerge overwrite
        delete inventoryDetails[index].images;
      }
    });
    dispatch(inventoryDuck.creators.addInventory(inventoryDetails));

    // open the quick save listings modal
    if (inventoryDetails.length > 0) {
      dispatch({
        type: userDuck.types.SHOW_QUICK_SAVE_LIST
      });
    }
  };
}